<template>
  <div>
    <routerView />
  </div>
</template>

<script>
export default {
  name: 'Index',

  components: {},

  mixins: [],

  props: {},

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
  },

  destroyed() {},

  methods: {},
};
</script>

<style lang="less"></style>
